/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const Main = styled.main`
  padding-top: ${({ urgentArticle, inPreview }) => {
    if (urgentArticle) {
      return inPreview ? '147px' : '97px';
    }
    return inPreview ? '114px' : '64px';
  }};

  @media (min-width: ${fullConfig.theme.screens.sm}) {
    padding-top: ${({ urgentArticle, inPreview }) => {
      if (urgentArticle) {
        return inPreview ? '175px' : '125px';
      }
      return inPreview ? '117px' : '67px';
    }};
  }

  @media (min-width: ${fullConfig.theme.screens.lg}) {
    padding-top: ${({ showSplitMenu, urgentArticle, inPreview }) => {
      if ((showSplitMenu && !urgentArticle) || (!showSplitMenu && urgentArticle)) {
        return inPreview ? '182px' : '132px';
      }
      if (urgentArticle && showSplitMenu) {
        return inPreview ? '235px' : '185px';
      }
      return inPreview ? '140px' : '90px';
    }};

  @media (min-width: ${fullConfig.theme.screens.xxl}) {
    padding-top: ${({ showSplitMenu, urgentArticle, inPreview }) => {
      if ((showSplitMenu && !urgentArticle) || (!showSplitMenu && urgentArticle)) {
        return inPreview ? '200px' : '150px';
      }
      if (urgentArticle && showSplitMenu) {
        return inPreview ? '252px' : '202px';
      }
      return inPreview ? '158px' : '108px';
    }};
`;

export { Main };
